/* -----------------------------------------------------------------------------
 * Tako Link & Link-Button
 * -------------------------------------------------------------------------- */
import { getLogger } from './utils/logger-context';
import { resolveComponentScope } from './utils/resolveComponentScope';

const COMPONENT_NAME = 'Link';

export const init = (unresolvedScope: string | HTMLElement | unknown) => {
    const logger = getLogger();
    const scope = resolveComponentScope(unresolvedScope);
    const defaultLoggerArgs = {
        componentName: COMPONENT_NAME,
        scope,
    };
    logger.debug(`Initialising ${COMPONENT_NAME} component.`, { scope });

    const allTakoLinks = scope.querySelectorAll<HTMLAnchorElement>(
        'a.tako-link, a.tako-button',
    );

    allTakoLinks.forEach((link) => {
        try {
            if (
                link.classList.contains('disabled') &&
                link.getAttribute('aria-disabled') !== 'true'
            ) {
                // Failsafe: Strip the `href` if it slipped into the HTML
                if (link.hasAttribute('href')) {
                    link.removeAttribute('href');
                }

                link.setAttribute('role', 'link');
                link.setAttribute('aria-disabled', 'true');
            }
        } catch (error) {
            logger.error(error as string, {
                ...defaultLoggerArgs,
                element: link,
            });
        }
    });
};
